export enum ChatFlags {
  SHOW_WARNING,
}
